import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { AppTheme } from 'src/themes/muiTheme';

const paymentFormHeaderStyles = {
  root: (theme: AppTheme) => {
    const mobileMaxSize = theme.breakpoints.values.sm + 1;
    const mobile = theme.breakpoints.down(mobileMaxSize);
    const tabletMaxSize = theme.breakpoints.values.lg + 1;
    const tablet = theme.breakpoints.down(tabletMaxSize);

    return {
      display: 'flex',
      flexDirection: 'column',
      rowGap: '8px',
      marginBottom: '40px',
      [tablet]: {
        rowGap: '10px',
      },
      [mobile]: {
        display: 'none',
      },
    };
  },
  title: (theme: AppTheme) => {
    const tabletMaxSize = theme.breakpoints.values.lg + 1;
    const tablet = theme.breakpoints.down(tabletMaxSize);

    return {
      [tablet]: {
        fontSize: '42px',
        lineHeight: 'normal',
      },
    };
  },
};

export function PaymentFormHeader() {
  return (
    <Box component={'header'} sx={paymentFormHeaderStyles.root}>
      <Typography
        component={'h2'}
        variant={'h3'}
        sx={paymentFormHeaderStyles.title}
      >
        Payment Details
      </Typography>
      <Typography component={'p'} variant={'body1'}>
        Select your payment type and add your information to finalize your plan.
      </Typography>
    </Box>
  );
}
